import { Button, ICON_COLOR } from '@zep-us/zus';
import { LockIcon, SquareStackIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';

/**
 * MobileViewerLockedCTAButtons Props
 */
export interface MobileViewerLockedCTAButtonsProps {
  onCopy: () => void;
}

/**
 * MobileViewerLockedCTAButtons - 모바일용 뷰어 잠금된 퀴즈 CTA 버튼
 *
 * @description
 * 모바일 하단 고정 영역에 최적화된 잠금된 퀴즈 뷰어용 CTA 버튼입니다.
 * 복사 버튼과 비활성화된 입장 버튼을 가로 배치합니다.
 *
 * @example
 * ```tsx
 * <MobileViewerLockedCTAButtons
 *   onCopy={handleCopy}
 * />
 * ```
 */
export const MobileViewerLockedCTAButtons = ({
  onCopy
}: MobileViewerLockedCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full gap-sm" data-sentry-component="MobileViewerLockedCTAButtons" data-sentry-source-file="MobileViewerLockedCTAButtons.tsx">
      <Button size="md" intent="gradient" variant="contained" onClick={onCopy} leftSlot={<SquareStackIcon size="sm" fill={ICON_COLOR.inverse} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileViewerLockedCTAButtons.tsx">
        {t('common:detail.saveToMyQuiz')}
      </Button>
      <Button size="md" intent="alternative" variant="contained" disabled leftSlot={<LockIcon size="sm" fill={ICON_COLOR.strong} opacity={0.54} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileViewerLockedCTAButtons.tsx">
        {t('detail.cta.tutorial')}
      </Button>
    </div>;
};